import { useContext, useEffect, useState } from "react";
import client from "../../../contentfulClient";
import { MainContext } from "../../../MainContext";
import useScrollAnimation from "../../useAnimationScrolling";

export const TranslationServices = () => {
    const {
        translators,
        staticTexts: { translation: staticTexts },
        staticTexts: { learnMoreButton: learnMoreButton },
        staticTexts: { contactUsButton: contactUsButton },
        translationRef,
        openModal,
    } = useContext(MainContext);

    const animationConfig = {
        scale: [0, 1],
        opacity: [0, 1],
        duration: 1000,
        easing: "easeOutExpo",
    };

    useScrollAnimation(translationRef, animationConfig, translators);

    return (
        <div>
            <div
                className="baner-container"
                ref={(el) => {
                    if (el) translationRef.current[translators.length + 1] = el;
                }}
            >
                <div
                    className="image-information"
                    style={{
                        backgroundImage: `url(${staticTexts.image})`,
                    }}
                >
                    <div className="texts">
                        <p className="typography">{staticTexts.title}</p>
                        <hr />
                        <br />
                        <p className="typography_small">{staticTexts.subTitle}</p>
                        <br />
                        <div className="buttons">
                            <div className="btn-gray" onClick={() => openModal({ ...staticTexts })}>
                                {learnMoreButton.text}
                            </div>
                            <div className="btn-blue" onClick={() => openModal({type: "contact"})}>{contactUsButton.text}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="translator-container">
                <section className="translator-services">
                    <h2 className="">Professional Legal Translators</h2>

                    <div className="grid">
                        {translators.map((translator: any, index: number) => (
                            <div
                                className="translator-card"
                                ref={(el) => {
                                    if (el) translationRef.current[index] = el;
                                }}
                                key={index}
                            >
                                <img src={`${translator.image}`} alt="" className="image" />
                                <h3 className="title">{translator.title}</h3>
                                <p className="translator-description">{translator.subTitle}</p>
                                <div className="btn-gray" onClick={() => openModal({ ...translator })}>
                                    {learnMoreButton.text}
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};
